var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#FBFBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.157 11.7807C26.4769 12.0863 25.7558 12.287 25.0173 12.3762C25.7957 11.9032 26.3782 11.1589 26.6564 10.2819C25.9259 10.7236 25.1251 11.0331 24.2904 11.2005C23.7298 10.591 22.9866 10.1868 22.1765 10.0507C21.3665 9.91461 20.5348 10.0543 19.8109 10.4479C19.087 10.8416 18.5113 11.4672 18.1735 12.2276C17.8356 12.9879 17.7545 13.8404 17.9427 14.6524C16.4614 14.577 15.0122 14.1859 13.6894 13.5045C12.3665 12.8231 11.1995 11.8667 10.264 10.6973C9.93292 11.2751 9.75891 11.932 9.75985 12.6006C9.75985 13.913 10.4172 15.0724 11.4167 15.7512C10.8252 15.7323 10.2468 15.57 9.72956 15.2778V15.3249C9.72974 16.1989 10.0274 17.046 10.5721 17.7224C11.1168 18.3989 11.875 18.8632 12.7182 19.0365C12.1691 19.1877 11.5934 19.21 11.0346 19.1017C11.2723 19.854 11.7356 20.512 12.3597 20.9834C12.9838 21.4549 13.7373 21.7162 14.5149 21.7309C13.7421 22.3476 12.8573 22.8034 11.911 23.0724C10.9647 23.3413 9.97553 23.4182 9 23.2985C10.7029 24.4112 12.6853 25.0019 14.71 25C21.5628 25 25.3104 19.232 25.3104 14.2298C25.3104 14.0669 25.3059 13.9021 25.2988 13.741C26.0283 13.2054 26.6578 12.5418 27.1579 11.7816L27.157 11.7807Z",
    fill: "#181B1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.64b4c23d.svg";
export { ForwardRef as ReactComponent };